/**
 * Trava do teste headless de cadastro. Só arma com as duas variáveis,
 * fora de produção, e só com Supabase local ou de staging.
 * Não ligar na Vercel.
 */

export const SIGNUP_E2E_OTP_CODE = "424242"
export const SIGNUP_E2E_EMAIL_DOMAIN = "e2e.astra.test"
export const SIGNUP_E2E_NAME_PREFIX = "E2E Signup"
export const PROD_SUPABASE_REF = "otbtybakfcbzzgxqfytv"
export const STAGING_SUPABASE_REF = "tzrainhznsliqkyjohje"

/** Perfil criado pelo Playwright. Vale na fila e no cron, sem o harness armado. */
export function isSignupE2eProfileEmail(email: string | null | undefined): boolean {
  return (email ?? "").trim().toLowerCase().endsWith(`@${SIGNUP_E2E_EMAIL_DOMAIN}`)
}

export function isSignupE2eHarness(): boolean {
  if (process.env.ASTRA_SIGNUP_E2E !== "1") return false
  if (process.env.ASTRA_SIGNUP_E2E_CONFIRM !== "1") return false
  if (process.env.VERCEL_ENV === "production") return false
  const url = process.env.NEXT_PUBLIC_SUPABASE_URL ?? ""
  if (!url || url.includes(PROD_SUPABASE_REF)) return false
  const local = /localhost|127\.0\.0\.1/.test(url)
  const staging = url.includes(STAGING_SUPABASE_REF)
  return local || staging
}
